module.exports = __webpack_public_path__ + "img/DLS_QuestionMark_24.b6395644.svg";